import { useState } from "react";

export default function AuthForgotPassword({ state, onChange, onSuccess, onError, authService }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const result = await authService.forgotPassword(state.username);
      setLoading(false);

      if (typeof onSuccess === "function") {
        onSuccess({ action: "password", response: result });
      }
    } catch (err) {
      setLoading(false);
      const errorMessage = err.message || "An error occurred during confirmation";
      setError(errorMessage);

      if (typeof onError === "function") {
        onError(err);
      }
    }
  };

  return (
    <div className="mx-auto w-full max-w-md">
      <form onSubmit={handleForgotPassword} className="mb-4 rounded px-8 pt-6 pb-8">
        <h2 className="text-center">Forgot Password</h2>

        {error && (
          <div
            className="relative mt-4 mb-4 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
            role="alert"
          >
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="username">
            Username / Email
          </label>
          <input
            className="input-text"
            id="username"
            type="text"
            placeholder="Username or Email"
            value={state.username || ""}
            onChange={(e) => onChange("username", e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="flex items-center justify-center">
          <button
            className={`focus:shadow-outline rounded bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-700 focus:outline-none ${loading ? "cursor-not-allowed opacity-50" : ""}`}
            type="submit"
            disabled={loading}
          >
            {loading ? "Confirming..." : "Forgot Password"}
          </button>
        </div>
      </form>
    </div>
  );
}
